/**
 * Convert an API iCal URL to the user-friendly /Getcal/ URL.
 *
 * The /Getcal/ path is handled server-side by Laravel (web.php route +
 * .htaccess rewrite) so it serves raw text/calendar content directly.
 * This means the same URL works for:
 *  - Users to see/copy in the UI
 *  - Calendar subscription clients (Google, Yahoo, Outlook, Apple)
 *
 * API format:    https://domain.com/api/calendar/{person|workgroup}/{encodedId}/ical
 * Getcal format: https://domain.com/Getcal/{person|workgroup}/id/{encodedId}
 */
export function toGetcalUrl(apiIcalUrl) {
  if (!apiIcalUrl) return '';
  const match = apiIcalUrl.match(/\/calendar\/(person|workgroup)\/([^/]+)\/ical/);
  if (!match) return apiIcalUrl; // fallback to original if pattern doesn't match
  const [, calType, encodedId] = match;
  // Use VUE_APP_BASE_URL for the origin (e.g. https://church-scheduling-dev.com)
  const base = (process.env.VUE_APP_BASE_URL || window.location.origin).replace(/\/+$/, '');
  return `${base}/Getcal/${calType}/id/${encodedId}`;
}
